import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { Screen } from "@/shared/v2/queries/interfacesV2";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useScreenMutation = () => {
  const { t } = useTranslation();
  const branch = useBranchId();

  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.create"));
    },
    mutationFn: ({ ...body }: Screen) =>
      post2(`/internal/secure/pos/v1/kitchens/add/screen/${branch}`, body),
  });
  return mutation;
};

export default useScreenMutation;
